import { useContent } from '../content/ContentContext.jsx'
import { Em } from '../components/Em.jsx'
import { MediaFill } from '../components/MediaFill.jsx'
import { SectionNum } from '../components/SectionNum.jsx'
import { useDragScroll } from '../site/useDragScroll.js'

export function MethodSection() {
  const { content } = useContent()
  const m = content.method
  const dragRef = useDragScroll()
  return (
    <section className="section method" id="sec-method">
      <SectionNum sectionKey="method" />
      <h2>
        <Em pre={m.pre} em={m.em} post={m.post} />
      </h2>
      <div className="scenes-head">
        <div className="eyebrow">{m.overline}</div>
        <div className="caption">SWIPE · DRAG</div>
      </div>
      <div className="scenes" ref={dragRef}>
        {m.scenes.map((s, i) => (
          <div className="scene" key={s.id}>
            <MediaFill id={s.media} />
            <div className="stex"></div>
            <div className="sov"></div>
            <div className="sidx">{String(i + 1).padStart(2, '0')}</div>
            <div className="slabel caption" style={{ color: 'var(--bone)' }}>
              {s.label}
            </div>
          </div>
        ))}
      </div>
      <div className="method-statement">
        <p className="pull">{m.statement}</p>
        <div className="caption sub">{m.subtext}</div>
      </div>
    </section>
  )
}
